import { addSeconds, format } from 'date-fns';

/**
 * Method that return a text time formatted
 * @param {number} durationInMinutes number of duration in minutes.
 * @returns timeFormatted
 */
export function formatDuration(durationInSeconds) {
  const durationInMinutes = durationInSeconds / 60;
  const hours = Math.floor(durationInMinutes / 60);
  const minutes = Math.floor(durationInMinutes) - (hours * 60);
  const hoursSuffix = hours > 1 ? 'hs' : 'h';
  const hoursText = hours >= 1 ? `${hours} ${hoursSuffix}` : '';
  const minutesText = minutes > 0 ? `${minutes} min` : '';

  return `${hoursText} ${minutesText}`.trim();
}

/**
 * Returns a string with the correct format of the starting time plus the seconds param.
 * @param {startTime} startTime - The date starts content.
 * @param {number} time - The time to format in seconds
 * @returns {string} The formatted time
 */
export function formatLiveTooltip(startTime, time) {
  const dateFormat = 'H:mm:ss';
  if (startTime && (time || time === 0) && time !== Number.POSITIVE_INFINITY) {
    return format(addSeconds(startTime, time), dateFormat);
  }
  return '00:00:00';
}
